import React from 'react';
import { InboxWebhookHealthView } from '../../types/metaWebhook';

interface InboxWebhookHealthBadgeProps {
  health?: InboxWebhookHealthView;
}

type ResolvedInboxWebhookHealth = Exclude<InboxWebhookHealthView, { status: 'loading' }>;

function resolveBadge(health: ResolvedInboxWebhookHealth): { className: string; tooltip: string } {
  if (health.status === 'synced')
  {
    return {
      className: 'bg-green-500',
      tooltip: 'Canal conectado e pronto para receber mensagens.',
    };
  }

  if (health.status === 'not_configured' || health.status === 'mismatch')
  {
    return {
      className: 'bg-amber-400',
      tooltip: 'Configuração pendente. Abra a caixa para finalizar.',
    };
  }

  return {
    className: 'bg-red-500',
    tooltip: `Não foi possível verificar o canal: ${health.message}`,
  };
}

export const InboxWebhookHealthBadge: React.FC<InboxWebhookHealthBadgeProps> = ({ health }) => {
  if (!health || health.status === 'loading')
  {
    return (
      <span
        className="inline-block h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"
        title="Verificando conexão do canal..."
        aria-label="Verificando conexão do canal..."
      />
    );
  }

  const badge = resolveBadge(health);

  return (
    <span
      className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${badge.className}`}
      title={badge.tooltip}
      aria-label={badge.tooltip}
    />
  );
};

export function canRegisterInboxWebhook(health?: InboxWebhookHealthView): boolean {
  return health?.status === 'mismatch'
    || health?.status === 'error';
}
